import React from 'react'

import { Field } from 'react-form'

import { Dropdown } from 'primereact/dropdown'

import FieldMessage from './FieldMessage'

import { validateFromRule, getRuleForField } from '../../js/validation'

import '../../css/field.css'

// this ia wrapper function for the prime react dropdown so it can work with react-form's form object
// make sure it is used with Form tags
// this allows the value of the form to read and updated in the form

// the reason this is done is because prime react's components are examples of controlled components
// they have a value set that binds to the state or props so that when that state or props is udated the component is re-rendered
// the onChange of the component needs to be handled to update the value of the state or props otherwise the user input will not be picked up
// use react-form's setValue function will update the state of the field on the form so that changes will be reflected

// pass in the field as the property name to bind and the label as what is displayed
// showAsTextOnly is used to disable the component, hide the component styling and make it look like text only
// options is the array of objects that will make up the drop down options to select from
/*
  <Form>
  {formApi => {
      return (
      <form>
          <div className=""p-grid">
              <div className="p-col-12">
                    <FieldDropdown field={"RestrictionLookup"} label={"Restriction"} options={employeeRestrictions} validationRules={validationRules} showAsTextOnly={showAsTextOnly}/>
              </div>
          </div>
      </form>
      )}
  }
  </Form>
*/
class FieldDropdown extends React.Component {
  render() {
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
    }
    return (
      // Use the form field and your custom input together to create your very own input!
      // field is the property name that is bound to in the form
      // validate is a function used to validate the field
      <Field field={this.props.field} validate={this.validate}>
        {fieldApi => {
          // fieldApi properties can found at https://react-form.js.org/#/custom-input
          // Remember to pull off everything you dont want ending up on the element otherwise it will throw errors
          // this extracts things out of the props passed in and leaves ...rest to be the rest of the properties
          // this way can pass in the extra properties to the prime react component
          const { onBlur, onChange, validate, field, label, inputStyle, validationRules, showAsTextOnly, ...rest } = this.props
          // value and setValue read and update value in the form
          const { value, setValue, setTouched, error, warning, success } = fieldApi

          let hasValidationRule = typeof validationRule !== "undefined"
          let isRequired = hasValidationRule && validationRule.IsRequired === true
          let id = field
          let idError = field + '_error'
          let currentValue = null
          if (value)
          {
            currentValue = value.CodeLovId;
          }
          const genders = this.props.options

          return (
            <div className="p-grid"> 
              <div className="p-col-12 field-label-container">
                <label htmlFor={id} aria-labelledby={this.props.label}>
                  {this.props.label}
                  {isRequired === true && <span className="required-field-label"></span>}
                </label>
              </div>
              <div  className="p-col-12 field-element-container"   >
             
              

        <select {...rest} className="p-inputtext"  value={currentValue || ''}  style={inputStyle}
                  onChange={e => {
                    if (onChange) { onChange(e) }
                    //let value = this.props.options.filter
                    genders.forEach(option => {
                       if(option.CodeLovId == e.target.value ) 
                       {
                        setValue(option)
                       }

                    })
                    
                  }}
                  onblur={e => {
                    setTouched()
                    if (onBlur) {
                      onBlur(e)
                    }
                  }}
              
              >
                <option key="" value="" ></option>
                      {genders.map((option) => <option key={option.CodeLovId} value={option.CodeLovId} >{option.Description}</option>)}
              </select>
                
              </div>
              {(error || warning || success) && <div className="p-col-12">
                {error ? <FieldMessage color="rgb(179, 0, 0)" message={error} id={idError} /> : null}
                {!error && warning ? <FieldMessage color="orange" message={warning} /> : null}
                {!error && !warning && success ? <FieldMessage color="green" message={success} /> : null}
              </div>}
            </div>
          )
        }}
      </Field>
    )
  }

  /*
    generic validation handler for input field
    checks the validation rules
    TODO - optional validation passed in as a props
  */
  validate = value => {
    let validationResult = {}
    let validationRule = {}
    if (this.props.validationRules) {
      validationRule = getRuleForField(this.props.validationRules, this.props.field)
      if (validationRule) {
        validationResult = validateFromRule(validationRule, value)
      }
    } else {
      validationResult.success = ''
    }
    return validationResult
  }
}

export default FieldDropdown;



// WEBPACK FOOTER //
// ./src/components/common/FieldDropdown.js